import React from "react";

const StartPage = () => {
  return (
    <div style={styles.container}>
      <p style={styles.text}>Please select from menu bar to navigate</p>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '80vh',
    width: '100vw',
    margin: 0,
    padding: 0,
  },
  text: {
    fontSize: '24px',
    color: '#333',
    textAlign: 'center',
    padding: '20px',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    maxWidth: '80%',
  }
};

export default StartPage;